var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-detail"},[(_vm.status === 'success')?_c('v-alert',{attrs:{"type":"success"}},[_vm._v(" "+_vm._s(_vm.successText)+" ")]):_vm._e(),(_vm.status === 'error')?_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" "+_vm._s(_vm.errorText)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }